<style lang="sass">

    .newsletter-form
        @import ../../../common/styles/settings
        @import ../../../common/styles/mixins

        &.vuedal
            margin: 0
            width: 700px
            top: 0
            transform: translate(-50%, 0%) !important

            +media("height>760px")
                top: 50%
                transform: translate(-50%, -50%) !important



            +media("<=900px")
                padding: 1rem
                top: 1rem
                width: calc(100% - 4rem)
                margin: 0
                transform: translate(-50%, 0%)!important

            header
                margin-bottom: -30px
                .close
                    margin-top: 1rem
                    margin-right: 1.5rem
                    color: black
                    font-size: 1.5rem
                    +media("<=900px")
                        margin-top: -0.5rem
                        margin-right: 0

        background: white
        padding: 3rem
        +media("<=900px")
            padding: 0

        &__title
            text-align: center
            font-size: 1rem
            margin: .5rem 1rem
            font-family: Montserrat, sans-serif

        &__type
            display: flex
            margin: 2rem 0
            +media("<=900px")
                flex-direction: column

        &__type-item
            flex-basis: calc(50% - .5rem)
            text-align: center
            padding: 1rem
            border: 1px solid black
            cursor: pointer
            position: relative
            transition: background $speed-normal $authentic-motion-out, border $speed-normal $authentic-motion-out
            +media("<=900px")
                width: 100%
                box-sizing: border-box
            &:first-child
                margin-right: 1rem
                +media("<=900px")
                    margin-right: 0
                    margin-bottom: 1rem
            &.active
                background: $color-base
                border: 1px solid $color-base
                color: white

            &:after
                position: absolute
                content: ""
                width: 1rem
                height: 1rem
                top: 1.1rem
                right: 3rem
                background-image: url(../../../common/graphics/check.svg)
                background-repeat: no-repeat
                background-size: contain
                +media("<=900px")
                    right: 1rem

        &__section
            margin-top: 1rem
            font-family: Montserrat, sans-serif


        input::-webkit-input-placeholder
            color: $color-gray-medium
            font-size: 0.8rem

        input
            width: 100%
            border: 0
            border-bottom: 1px solid $color-text
            padding: 0.25rem 0 0.5rem 0
            outline-width: 0
            border-radius: 0
            &[aria-invalid="true"]
                border-bottom: 1px solid $color-base

        &__line
            display: flex
            margin-bottom: 1rem

        &__input
            flex-grow: 1

        &__input + &__input
            margin-left: 1rem

        &__actions
             margin-top: 2rem
             text-align: center

        .button
            padding: 1rem 2rem

        &__error
            position: absolute
            margin-top: .25rem
            font-size: 0.5rem
            color: $color-base
</style>

<script>

    import fr from 'vee-validate/dist/locale/fr'

    import Vue from "vue";
    import VeeValidate, { Validator } from "vee-validate"
    // import {Bus as VuedalsBus} from "vuedals";
    import { findIndex, reduce, each } from "lodash/core";
    import $ from "jquery";

    Validator.localize('fr', fr);
    Vue.use(VeeValidate);


    export default {

        mounted: function() {
            this.$newsletterItems = $(".node-newsletter__item");
        },
        data: () => ({
            type: "part",
            form: {
                society: '',
                firstname: '',
                lastname: '',
                email: '',
                address: {}
            }
        }),

        props: [
            "newsletters"
        ],

        computed: {

            hasPaper() {
                return findIndex(this.newsletters, (newsletter) => newsletter.indexOf("papier") > -1 ) > -1
            },

            hasEmail() {
                return findIndex(this.newsletters, (newsletter) => newsletter.indexOf("email") > -1 ) > -1
            }

        },

        methods: {

            setType: function(type) {
                this.type = type;
            },

            hasNewsletter(type) {
                return ( this.newsletters.indexOf(type) > -1 );
            },

            postData: function() {
                let data =
                    [
                        { id: 'edit-type-part', type: 'checkbox', value: ( this.type === 'part' ) },
                        { id: 'edit-type-pro', type: 'checkbox', value: ( this.type === 'pro' ) },
                        { id: 'edit-society', type: 'text', value: this.form.society },
                        { id: 'edit-firstname', type: 'text', value: this.form.firstname },
                        { id: 'edit-lastname', type: 'text', value: this.form.lastname },
                        { id: 'edit-email', type: 'text', value: this.form.email },
                        { id: 'edit-address', type: 'text', value: reduce(this.form.address, (sum, item) => sum + " " + item) }
                    ];

                this.$newsletterItems.each((index, obj) => {
                    let code = $(obj).attr('code');
                    data.push({
                        id: 'edit-newsletters-' + code.replace(/_/g, '-'),
                        type: 'checkbox',
                        value: this.hasNewsletter(code)
                    });
                });


                this.$validator.validateAll().then(response => {
                    if ( this.type && this.newsletters.length && response ) {
                        this.fillForm("webform-submission-newsletter-node-85-form", data);
                    }
                }).catch(e => { console.log(e); });
            },

            fillForm(formId, data) {
                each(data, (item, index) => {
                    let $input = $("#" + item.id);
                    if ( $input.length ) {
                        switch ( item.type ) {
                            case "checkbox" :
                                if ( item.value )
                                    $input.attr("checked", true);
                                else
                                    $input.removeAttr("checked");
                                break;
                            case "text" :
                                $input.val(item.value);
                                break;
                        }
                    }
                });
                console.log($("#" + formId))

                $(".page-type-newsletter form").submit();
            }

        }
    }
</script>

<template lang="pug">

<!--  .newsletter-form-->


<!--      .newsletter-form__title-->
<!--          | Veuillez remplir les champs ci-dessous afin de recevoir<br/> vos newsletters préférées.-->

<!--      .newsletter-form__type-->
<!--          .newsletter-form__type-item(:class="{'active' : type == 'part' }", @click="setType('part')")-->
<!--              | Particulier-->
<!--          .newsletter-form__type-item(:class="{'active' : type == 'pro' }", @click="setType('pro')")-->
<!--              | Entreprise-->

<!--      .newsletter-form__line(v-if="type == 'pro'")-->
<!--          .newsletter-form__section-->
<!--              label Société-->

<!--      .newsletter-form__line(v-if="type == 'pro'")-->
<!--          .newsletter-form__input-->
<!--              input(v-model.lazy="form.society", name="society", v-validate="'required'", placeholder="Nom de la société", value="")-->

<!--      .newsletter-form__line-->
<!--          .newsletter-form__section-->
<!--              label Prénom et Nom-->

<!--      .newsletter-form__line-->
<!--          .newsletter-form__input-->
<!--              input(v-model.lazy="form.firstname", name="firstname", data-vv-as="Prénom", v-validate="'required|alpha'", placeholder="Prénom", value="")-->
<!--              .newsletter-form__error {{ errors.first('firstname') }}-->
<!--          .newsletter-form__input-->
<!--              input(v-model.lazy="form.lastname", name="lastname", data-vv-as="Nom", v-validate="'required|alpha'", placeholder="Nom")-->
<!--              .newsletter-form__error {{ errors.first('lastname') }}-->

<!--      .newsletter-form__line(v-if="hasEmail")-->
<!--          .newsletter-form__section-->
<!--              label Adresse e-mail-->

<!--      .newsletter-form__line(v-if="hasEmail")-->
<!--          .newsletter-form__input-->
<!--              input(v-model.lazy="form.email", name="email", data-vv-as="Email", v-validate="'required|email'", placeholder="Adresse e-mail")-->
<!--              .newsletter-form__error {{ errors.first('email') }}-->

<!--      .newsletter-form__line(v-if="hasPaper")-->
<!--          .newsletter-form__section-->
<!--              label Adresse postale-->

<!--      //.newsletter-form__line-->
<!--          .newsletter-form__input-->
<!--              input(v-model="form.address.firstname", name="adsress_firstname", v-validate="'required'", placeholder="Prénom", value="")-->
<!--          .newsletter-form__input-->
<!--              input(v-model="form.address.lastname", name="adsress_lastname", v-validate="'required'", placeholder="Nom")-->

<!--      .newsletter-form__line(v-if="hasPaper")-->
<!--          .newsletter-form__input-->
<!--              input(v-model.lazy="form.address.address", name="address_address", data-vv-as="Adresse", v-validate="'required'", placeholder="Adresse")-->
<!--              .newsletter-form__error {{ errors.first('address_address') }}-->

<!--      .newsletter-form__line(v-if="hasPaper")-->
<!--          .newsletter-form__input-->
<!--              input(v-model="form.address.zipcode", name="address_zipcode", data-vv-as="Code postal", v-validate="'required|digits:5'", placeholder="Code postal")-->
<!--              .newsletter-form__error {{ errors.first('address_zipcode') }}-->
<!--          .newsletter-form__input(style="flex-basis: 70%")-->
<!--              input(v-model.lazy="form.address.city", name="address_city", data-vv-as="Ville", v-validate="'required'", placeholder="Ville")-->
<!--              .newsletter-form__error {{ errors.first('address_city') }}-->

<!--      .newsletter-form__actions-->
<!--          a.button.button&#45;&#45;black(@click="postData") Je m'abonne-->

<!--      //div.popin__content.form-->
<!--      //.form__field.form__field&#45;&#45;half-->
<!--        input(v-model="form.firstname", name="firstname", v-validate="'required'", placeholder="Nom")-->
<!--        // span.form__ok(v-show="fields.valid('firstname')")-->
<!--        span.form__error(v-show="errors.has('firstname')")-->
<!--        span.form__error__label(v-show="errors.has('firstname')") Ce champ est requis-->

<!--      //.form__field.form__field&#45;&#45;half-->
<!--        input(v-model="form.lastname", name="lastname", v-validate="'required'", placeholder="Prénom")-->
<!--        // span.form__ok(v-show="fields.valid('lastname')")-->
<!--        span.form__error(v-show="errors.has('lastname')")-->
<!--        span.form__error__label(v-show="errors.has('lastname')") Ce champ est requis-->

<!--      //.form__field.form__field&#45;&#45;full-->
<!--        input(v-model="form.email", name="email", v-validate="'required|email'", placeholder="Adresse Email")-->
<!--        // span.form__ok(v-show="fields.valid('email')")-->
<!--        span.form__error(v-show="errors.has('email')")-->
<!--        span.form__error__label(v-show="errors.has('email')") Ce champ est invalide-->

<!--      //.form__field.form__field&#45;&#45;full-->
<!--        input(v-model="form.zipcode", name="zipcode", v-validate="{ rules: { required: true, digits: 5 } }", placeholder="Code Postal")-->
<!--        // span.form__ok(v-show="fields.valid('zipcode')")-->
<!--        span.form__error(v-show="errors.has('zipcode')")-->
<!--        span.form__error__label(v-show="errors.has('zipcode')") Ce champ est invalide-->

<!--      //.form__field.form__field&#45;&#45;full(style="margin-top:1rem")-->
<!--        input#terms(v-model="form.terms", name="terms", v-validate="{ rules: { required: true } }", type="checkbox")-->
<!--        label(for="terms") Oui, j’ai pris connaissance du <a href="/modules/TetrisMaliceModule/Reglement-du-jeu-Bloc-a-Malice.pdf" target="_blank">règlement</a>.-->
<!--        span.form__error__label(v-show="errors.has('terms')") Ce champ est requis-->

<!--      //a.popin__button(@click="postData()") Je participe-->
<!--      //div.popin__content__or ou-->

</template>
